import { useEffect } from 'react'
import { APP_VERSION } from '../version'

const VERSION_KEY = 'rentalcheck-app-version'

export function useVersionReload() {
  useEffect(() => {
    const stored = localStorage.getItem(VERSION_KEY)

    if (stored && stored !== APP_VERSION) {
      console.log(`[version] Nouvelle version détectée: ${stored} → ${APP_VERSION}. Rechargement...`)
      localStorage.setItem(VERSION_KEY, APP_VERSION)
      // Vide le cache service worker si présent
      if ('caches' in window) {
        caches.keys().then(keys => {
          keys.forEach(key => caches.delete(key))
        })
      }
      // Force reload sans cache
      window.location.reload(true)
      return
    }

    // Première visite ou même version
    localStorage.setItem(VERSION_KEY, APP_VERSION)
    console.log(`[version] App v${APP_VERSION} chargée`)
  }, [])
}